export default "__VITE_ASSET__Bokh$BV___"